import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  contentBox: {
    backgroundColor: theme.palette.bkg.secondary,
    textAlign: "center",
    padding: 24,
    height: "calc(100% - 40px)",
  },
}));
